/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';

const propTypes = {
  keyName: React.PropTypes.string.isRequired,
  sortName: React.PropTypes.string.isRequired,
  sortOrder: React.PropTypes.string.isRequired,
  handleSortChange: React.PropTypes.func.isRequired,
};

class SortFlag extends React.Component {
  handleClick(sortOrder) {
    const { keyName } = this.props;
    this.props.handleSortChange({ sortName: keyName, sortOrder });
  }

  render() {
    const { sortName, sortOrder, keyName } = this.props;
    if (sortName === keyName) {
      if (sortOrder === 'desc') {
        return (
          <span onClick={() => this.handleClick('asc')}>
            <span className={`fa fa-caret-down ${styles.flag} ${styles.select}`} />
            <span className={`fa fa-caret-up ${styles.flag}  ${styles.hidden}`} />
          </span>
        );
      }

      return (
        <span onClick={() => this.handleClick('desc')}>
          <span className={`fa fa-caret-up ${styles.flag}  ${styles.select}`} />
          <span className={`fa fa-caret-down ${styles.flag} ${styles.hidden}`} />
        </span>
      );
    }

    return (
      <span onClick={() => this.handleClick('desc')}>
        <span className={`fa fa-caret-down ${styles.flag}`} />
        <span className={`fa fa-caret-up ${styles.flag}`} />
      </span>
    );
  }
}
SortFlag.propTypes = propTypes;
export default SortFlag;




// WEBPACK FOOTER //
// ./src/containers/Network/coms/GatewayView/coms/SortFlag/index.jsx